import { compose } from 'recompose';

import StampFilterItemView from './StampFilterItemView';

export default compose()(StampFilterItemView);
